<template>
    <div class="wrapper-restricted">
        <div class="logo=restricted">
            <div class="logo-restricted">
                <img src="./images/logo.svg" alt="">
            </div>
            <div class="stop-restricted">
                <img src="./images/stop.svg" alt="">
            </div>
            <h1 class="title-restricted">Access to our Services <br>is Restricted from Russia!</h1>
            <div class="text-restricted">Due to a full-scale and unprovoked war Russia started against Ukraine, which is absolutely
                unprecedented and intolerable for the whole world together with resulting sanctions imposed to the
                Russian Federation, we as a company, do not see any possibility for cooperation with Russian businesses.
            </div>
            <div class="text-restricted">We do everything we can to support Ukrainian citizens, and will not fund Russian
                aggression cooperating with Russian-owned companies.
            </div>
            <h2 class="bottom-title-restricted">Cлава Україні!</h2>
            <div class="flag">
                <img src="./images/flag.svg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "restricted",

}
</script>

<style>
@import './css/app.css';
@import url('https://fonts.googleapis.com');
@import url('https://fonts.gstatic.com');
@import url('https://fonts.googleapis.com/css2?family=Epilogue:wght@500;700&display=swap');

</style>
